export default __webpack_public_path__ + "static/about-thin-icon-f5b86455fb1f7045d81c486cbec4c6ed.png";